import { Cartesian3
 , Math as CesiumMath, Cartographic } from "cesium/Cesium";

 let CameraUtil = function(viewer) {
 };

 CameraUtil.prototype = {
   getCameraView(viewer) {
      this._position = viewer.camera.position.clone();
      this._heading = viewer.camera.heading;
      this._pitch = viewer.camera.pitch;
      let lon = CesiumMath.toDegrees(Cartographic.fromCartesian(this._position).longitude);
      let lat = CesiumMath.toDegrees(Cartographic.fromCartesian(this._position).latitude);
      let height = Cartographic.fromCartesian(this._position).height;
      let heading = CesiumMath.toDegrees(this._heading);
      let pitch = Math.abs(CesiumMath.toDegrees(this._pitch));
      return { position: [lon, lat, height], heading: heading, pitch: pitch };
   },
   getFlyTo(params) {
     let cmd = {
      destination: Cartesian3.fromDegrees(params.position[0], params.position[1], params.position[2]),
      orientation: {
          heading: CesiumMath.toRadians(params.heading),
          pitch: -CesiumMath.toRadians(params.pitch)
      }
    };
    return cmd;
   }
 };

 export default CameraUtil;

//  let cameraUtil = new CameraUtil();
//  let cv = null;
//  setTimeout(() => {
//    cv = cameraUtil.getCameraView(window.viewer);
//    console.log(cv, "cv ---------------");
//  }, 5000);
//  setTimeout(() => {
//    window.viewer.camera.flyTo(cameraUtil.getFlyTo(cv));
//  }, 15000);
